<template>
  <div class="flex-grow-1 overflow-auto full-height">
    <base-serve-table
      ref="table"
      :api="api"
      :headers="headers"
      :params.sync="params"
      :defaultParams="default_params"
      use-top
      @click:row="onClickItem"
    >
      <template #top-append-right>
        <div class="d-flex align-center">
          <v-chip v-if="version" small class="mr-2" outlined>
            Phiên bản: {{ version }}
          </v-chip>
          <base-button type-action="create" outlined @click="$emit('click:create')">
            Tạo mới
          </base-button>
        </div>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <div class="d-flex">
          <base-button-group
            class="full-width"
            :items="menus"
            :value="item"
            forceInList
          ></base-button-group>
        </div>
      </template>
    </base-serve-table>
    <FeatureInfo ref="featureDetail" />
  </div>
</template>

<script>
import { API_FEATURE } from '@api'
import { replaceLink } from '@utils'
import FeatureInfo from '../datastore-detail-item/feature-dialog.vue'
export default {
  components: { FeatureInfo },
  props: {
    id: { type: [Number, String], required: true },
    fields: { type: Array, required: true },
    version: { type: [Number, String], default: 1 },
  },
  data: (vm) => ({
    loading: false,
    default_params: {
      // sort: 'created_at',
    },
    headers: [],
    params: {},
    menus: [
      {
        title: 'Xem chi tiết dữ liệu',
        icon: 'mdi-information-outline',
        handler: (item) => {
          return vm.onShowDetail(item)
        },
      },
      {
        title: 'Sửa thông tin',
        icon: 'mdi-pencil-outline',
        handler: (item) => {
          return vm.$emit('click:update', item)
        },
      },
      {
        title: 'Xóa đối tượng',
        icon: 'mdi-delete-outline',
        color: 'error',
        handler: (item) => {
          return vm.$emit('click:delete', item)
        },
      },
    ],
  }),
  computed: {
    api() {
      return API_FEATURE.updateOption({
        url: replaceLink(API_FEATURE.getUrl(), { id: this.id }),
      })
    },
  },
  watch: {
    fields: {
      handler(value) {
        this.setFields(this.fields)
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.params = { page: null }
      this.show = true
    },
    onShowDetail(item) {
      let temp = { data: item, fields: this.fields }
      this.$refs.featureDetail.open(temp)
    },
    onClickItem(item) {
      this.$emit('click:row', item)
    },
    reload() {
      if (this.$refs.table && this.$refs.table.reload) {
        this.$refs.table.reload()
      }
    },
    setFields(fields) {
      this.headers = [
        ...convertFieldsToHeader(fields),
        {
          trans: 'field.action',
          value: 'action',
          sortable: false,
          hidden: false,
          width: '150px',
          align: 'center',
        },
      ]
    },
  },
}

export function convertFieldsToHeader(fields) {
  let MAX_FIELD_SHOW_INIT = 5
  return fields.reduce((acc, field, index) => {
    let type = field.type
    let format = null
    if (['array', 'geometry'].includes(field.type) || field.code === 'version') {
      return acc
    }
    acc.push({
      value: field['code'],
      type,
      text: field['name'],
      sortable: false,
      filterable: false,
      hidden: index >= MAX_FIELD_SHOW_INIT,
      format,
    })
    return acc
  }, [])
}
</script>

<style scoped></style>
